import React, {FC, PropsWithChildren} from 'react';

import {useHandleExternalLink} from 'features/intercept-file-download-anchor/hooks/use-handle-external-link';

interface IFileDownloadAnchorInterceptorProps {
    className?: string;
}

export const FileDownloadAnchorInterceptor: FC<PropsWithChildren<IFileDownloadAnchorInterceptorProps>> = (
    {children, className}: PropsWithChildren<IFileDownloadAnchorInterceptorProps>,
) => {
    const handleLinkClick = useHandleExternalLink();

    return (
        <div
            className={className}
            onClick={handleLinkClick}
        >
            {children}
        </div>
    );
};
